module.exports = __webpack_public_path__ + "img/jardin11.7a726f5a.jpg";